import { createAsyncThunk } from "@reduxjs/toolkit";
import ODataStore from "devextreme/data/odata/store";
import DataSource from "devextreme/data/data_source";
import { axios } from "../../common";
import OptionHeaders from "../options";
const { token, baseUrl } = OptionHeaders();

const APPROVAL_SETTING_DEPARTMENT_SHOW =
  "approval/showApprovalSettingDepartment";
const APPROVAL_SETTING_EMPLOYEE_SHOW = "approval/showApprovalSettingEmployee";
const APPROVAL_ALL_SHOW = "approval/showApprovalAll";
const APPROVAL_SETTING_CREATE = "approval/createApprovalSetting";

export const showApprovalSettingDepartment = createAsyncThunk(
  APPROVAL_SETTING_DEPARTMENT_SHOW,
  async (thunkAPI) => {
    try {
      const approval = new DataSource({
        store: new ODataStore({
          url: `${baseUrl}PivotApprovalSetting(Department)`,
          key: "Oid",
          version: 4,
          beforeSend: (request) => {
            request.headers["token"] = token;
          },
        }),
      });
      return approval;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const showApprovalSettingEmployee = createAsyncThunk(
  APPROVAL_SETTING_EMPLOYEE_SHOW,
  async (thunkAPI) => {
    try {
      const approval = new DataSource({
        store: new ODataStore({
          url: `${baseUrl}PivotApprovalSetting(Employee)`,
          key: "Oid",
          version: 4,
          beforeSend: (request) => {
            request.headers["token"] = token;
          },
        }),
      });
      return approval;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const showApprovalAll = createAsyncThunk(
  APPROVAL_ALL_SHOW,
  async (payload, thunkAPI) => {
    try {
      const { data } = await axios.get(`Approval(${payload})`);
      return data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const createApprovalSetting = createAsyncThunk(
  APPROVAL_SETTING_CREATE,
  async (payload, thunkAPI) => {
    try {
      const { data } = await axios.post(`ApprovalSetting`, payload);
      return data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
